import { CmsObjectWithDefault } from '@components/Cms/types';

export type OtpLoginPanelCmsKey = 'OtpLoginTitle' | 'BackToSignIn';

export const OtpLoginPanelCmsWithDefault: CmsObjectWithDefault<OtpLoginPanelCmsKey> = {
    OtpLoginTitle: {
        cmsId: 136310,
        defaultTranslation: 'OTP Login',
    },
    BackToSignIn: {
        cmsId: 67070,
        defaultTranslation: 'Back to sign in',
    },
};
